import request from '@/services/request'

export function fetchAll(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/sync-master-detail/list',
    method: 'get',
    params: data
  })
}






// WEBPACK FOOTER //
// ./src/api/sync_master_detail.js